import { CmsProtectionStartSummaryPanelBoilers } from '../../models/cms/cms-protection-start-summary-panel-boilers.interface';

export const mockCmsProtectionStartSummaryPanelBoilers: CmsProtectionStartSummaryPanelBoilers =
  {
    protectionStartSummaryPanelBodyBoilers:
      'If your appliance is in guarantee, cover will start once we have processed your application. If your appliance is out of guarantee, cover will start after a 30 day wait.',
    protectionStartSummaryPanelTitleBoilers: 'Plan starting date',
  };
